import { RequestTypes } from '../requestTypes'
import { registerKeys } from '../registerKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
export const useUpdateRegisterTrigger = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['updateRegisterTrigger']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerKeys.updateRegisterTrigger,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(registerKeys.registerSettings._def)
    },
  })
}
